import {Toast,Dialog} from 'vant'


import base_url from './config.js'

import axios from 'axios'
let BAS_URL = ""

function request (url,data,method="post"){
    BAS_URL = base_url+url
   
    return axios({
        method:method,
        url:BAS_URL,
        headers:{
                "Content-Type": "application/x-www-form-urlencoded;charset=utf-8",
            },
            // httpAgent: new http.Agent({ keepAlive: true }),
        params:{
            ...data,
            openid:window.localStorage.getItem("openid")
        }
      }).then((res)=>{
            if(res.data.code==200){
               
                return [undefined,res.data.data]
            }else{
                // Toast(res.data.message);
                Dialog.alert({
                    message:res.data.message,
                    messageAlign:"left",
                    allowHtml :true
                  }).then(() => {
                    // on close
                  });

                return [res.data.message,undefined]
            }
      }).catch((err)=>{
        Toast("网络错误！");
        return [err,undefined]
      })
}

export default request